import React from 'react';

const Diferenciador = () => {
  return (
    <section id="sello" className="section section-dark">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="image-organic order-2 md:order-1" style={{ maxHeight: '480px' }}>
            <img
              src="https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
              alt="Frasco de aceite esencial sobre pedestal de madera con sombras de hojas"
              width="900"
              height="1200"
              loading="lazy"
              decoding="async"
              style={{ maxHeight: '480px' }}
            />
          </div>

          <div className="order-1 md:order-2">
            <h2 className="heading-2 mb-6">
              Fitoterapia y aromaterapia aplicada al{' '}
              <em>bienestar corporativo</em>
            </h2>
            <p className="body-large">
              Mientras la mayoría de los programas de bienestar se quedan en
              charlas aisladas, en Nútrete incorporamos el uso responsable de
              plantas medicinales y aromaterapia como herramienta concreta de
              bienestar organizacional. No es un complemento decorativo: es
              parte del diseño de cada programa, desde talleres prácticos hasta
              intervenciones sensoriales en espacios de trabajo.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Diferenciador;
